import React, { useState, useMemo } from 'react';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

import './evaluacion-danos.css';

// `partes`: [{ id_parte, nombre }, ...] — viene de tu tabla de catálogo (~72 items)
// `value`: { [id_parte]: 'Bueno' | 'Averiado' }
// `onChange`: (nuevoValue) => void
function EvaluacionDanosLista({ partes = [], value = {}, onChange }) {
  const [busqueda, setBusqueda] = useState('');

  const partesFiltradas = useMemo(() => {
    if (!busqueda) return partes;
    const q = busqueda.toLowerCase();
    return partes.filter((p) => p.nombre.toLowerCase().includes(q));
  }, [partes, busqueda]);

  const totalEvaluadas = Object.keys(value).length;
  const totalAveriadas = Object.values(value).filter((v) => v === 'Averiado').length;

  const marcar = (idParte, estado) => {
    const actual = value[idParte];
    const nuevo = { ...value };
    if (actual === estado) {
      // clickear la misma opción activa la desmarca (vuelve a "sin evaluar")
      delete nuevo[idParte];
    } else {
      nuevo[idParte] = estado;
    }
    onChange?.(nuevo);
  };

  const marcarTodoBueno = () => {
    const nuevo = { ...value };
    partes.forEach((p) => {
      if (!nuevo[p.id_parte]) nuevo[p.id_parte] = 'Bueno';
    });
    onChange?.(nuevo);
  };

  const limpiarTodo = () => {
    onChange?.({});
  };

  return (
    <div>
      <div className="revision-acciones">
        <span className="p-input-icon-left" style={{ minWidth: 220 }}>
          <IconField iconPosition="left" className="input-icon-field">
            <InputIcon className="pi pi-search pt-1" />
            <InputText
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              placeholder="Buscar parte..."
              maxLength={25}
              className="w-100"
              style={{ height: '2rem', paddingLeft: '2.2rem' }}
            />
          </IconField>
        </span>

        <div className="revision-acciones-botones">
          <Button
            type="button"
            label='Marcar todo "Bueno"'
            icon="pi pi-check"
            className="btn-outline-azul"
            onClick={marcarTodoBueno}
          />
          <Button
            type="button"
            label="Limpiar"
            icon="pi pi-refresh"
            className="btn-outline-rojo"
            onClick={limpiarTodo}
            disabled={totalEvaluadas === 0}
          />
        </div>
      </div>

      <small className="text-muted d-block mb-2">
        {totalEvaluadas}/{partes.length} evaluadas
        {totalAveriadas > 0 && (
          <span className="text-danger ms-2">— {totalAveriadas} averiada{totalAveriadas === 1 ? '' : 's'}</span>
        )}
      </small>

      <div className="revision-danos-grid">
        {partesFiltradas.map((p) => {
          const estado = value[p.id_parte];
          return (
            <div key={p.id_parte} className="revision-danos-item">
              <span className="revision-danos-nombre">{p.nombre}</span>
              <div className="revision-danos-botones">
                <button
                  type="button"
                  className={classNames('revision-danos-btn revision-danos-btn--bueno', {
                    'revision-danos-btn--activo': estado === 'Bueno',
                  })}
                  onClick={() => marcar(p.id_parte, 'Bueno')}
                  aria-label={`Marcar ${p.nombre} como bueno`}
                >
                  <i className="pi pi-check" />
                </button>
                <button
                  type="button"
                  className={classNames('revision-danos-btn revision-danos-btn--averiado', {
                    'revision-danos-btn--activo': estado === 'Averiado',
                  })}
                  onClick={() => marcar(p.id_parte, 'Averiado')}
                  aria-label={`Marcar ${p.nombre} como averiado`}
                >
                  <i className="pi pi-times" />
                </button>
              </div>
            </div>
          );
        })}

        {(partesFiltradas.length === 0) && (
          <p className="text-muted">No hay partes que coincidan con "{busqueda}".</p>
        )}

      </div>
    </div>
  );
}

export default EvaluacionDanosLista;
